import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import Cookies from 'js-cookie';
import Cart from './cart';

export function toData(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}

export default class Shop {
  cart: Cart;
  callback: () => void;
  sequence: number;

  constructor() {
    this.cart = new Cart();
    this.callback = () => undefined;
    this.sequence = 0;
  }

  copy() {
    const s = new Shop();
    s.cart = this.cart;
    s.callback = this.callback;
    s.sequence = this.sequence;
    return s;
  }

  setCallback(cb: () => void) {
    this.callback = cb;
  }

  notify() {
    this.sequence += 1;
    this.callback();
  }

  loadCookieCart(): string | undefined {
    return Cookies.get('ShopCart');
  }

  saveCookieCart(id: string) {
    Cookies.set('ShopCart', id);
  }

  async loadCart() {
    await this.cart.load(this.loadCookieCart());

    if (this.cart.isValid()) {
      this.notify();
    }
  }

  async createCart() {
    await this.cart.create();

    if (this.cart.isValid()) {
      this.saveCookieCart(this.cart.getId());
      this.notify();
    }
  }

  async loadOrCreate() {
    if (!this.cart.isValid()) {
      await this.loadCart();
    }

    if (!this.cart.isValid()) {
      await this.createCart();
    }

    if (this.cart.isValid()) {
      this.notify();
    }
  }

  ensureLoad() {
    this.loadOrCreate(); //async
  }

  async resetCart() {
    await this.createCart();
  }

  async addItemToCart(itemId: string) {
    await this.loadOrCreate();
    await this.cart.addItem(itemId);
    this.notify();
    console.log('added item to cart: ', this.cart.cart?.id);
  }

  getCheckoutUrl() {
    return this.cart.getCheckoutUrl();
  }

  getLineItemCount() {
    return this.cart.getLineItemCount();
  }

  getLineItems() {
    return this.cart.getLineItems();
  }

  async removeItem(id: string) {
    await this.cart.remItem(id);
    this.notify();
  }

  async setNote(note: string) {
    await this.cart.setNote(note);
    this.notify();
  }

  async updateLineItem(id: string, count: number) {
    await this.cart.updateItem(id, count);
    this.notify();
  }

  getCost() {
    return this.cart.getCost();
  }

  async isVariantAvailable(pid: string, vid: string, availDefault: boolean) {
    return this.cart.isAvailable(pid, vid, availDefault);
  }
}
